import React, { Component } from 'react';
import { wallData } from '../utils';
import WallNavImage from '../molecules/WallNavImage';
import WallNavLinks from '../molecules/WallNavLinks';

class WallNav extends Component {

  resizeHandler = ( height ) => {
    this.props.imageResizeHandler( height );
  };

  render() {
    return (
      <div className="WallNav">
        <div className="start">
          <p className="small">{wallData( this.props.wall ).start}</p>
        </div>
        <div className="WallHolder">
          <WallNavImage wall={this.props.wall} resizeHandler={this.resizeHandler}/>
          <WallNavLinks
            wall={this.props.wall}
            height={this.props.wallHeight}
            setIndex={this.props.setIndex}
            locationList={this.props.locationList}
            currentLocationIndex={this.props.currentLocationIndex} />
        </div>
        <div className="end">
          <p className="small">{wallData( this.props.wall ).end}</p>
        </div>
      </div>
    )
  }
}

export default WallNav;